import React from "react";

export default function Modal({ title, children, onClose, width }) {
  // Optional `width` overrides the default modal width — useful for forms
  // that need more horizontal room (e.g. formula editors).
  const style = width ? { maxWidth: width, width: "min(95vw, " + width + ")" } : undefined;
  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal fade-in" style={style} onClick={(e) => e.stopPropagation()}>
        {title && <h3 className="modal-title">{title}</h3>}
        {children}
      </div>
    </div>
  );
}

export function ModalActions({ onCancel, onConfirm, confirmLabel = "Confirm", disabled = false }) {
  return (
    <div className="flex justify-end gap-10 mt-20">
      <button className="btn btn-ghost" onClick={onCancel}>Cancel</button>
      <button className="btn btn-primary" onClick={onConfirm} disabled={disabled}>{confirmLabel}</button>
    </div>
  );
}
